import { SupplierMatchGridView } from "@/components/supplier-match/SupplierMatchGridView";
import { createRoute } from "@tanstack/react-router";

import { accountRoute } from "./account-page";

// The salon's Supplier Match settings (ADR-0005). Same grid component and
// data as the home dashboard's onboarding invite - this route is just the
// permanent, always-reachable home for it.
export const accountSupplierMatchRoute = createRoute({
  getParentRoute: () => accountRoute,
  path: "supplier-match",
  component: SupplierMatchGridView
});
